import { Container } from '@mantine/core'
import { BookingForm } from '../../components/BookingForm'
import { useStorageContext } from '@/contexts/StorageContext';



export function BookingPage() {
  const storageContext = useStorageContext()

  const handleBookingSubmit = (bookingData: any) => {
    console.log('Booking submitted:', bookingData);
    // Здесь можно добавить дополнительную логику обработки записи
  };

  return (
    <Container size="xl" py="xl"> 
      <BookingForm 
        apiUrl={storageContext.apiUrl}
        ptoName={storageContext.ptoName}
        services={storageContext.singupServices}
        onBookingSubmit={handleBookingSubmit}
      />
    </Container>
  )
}